module.exports = __webpack_public_path__ + "static/media/7.3c5edd57.png";